import { BankAccount } from 'commons/types/DTO/bank/companyDetails/bankAccount'
import { CheckBox, IconSize, Link, TableActions, TableColumn, TextMask } from 'ui/components'

import { BANK_ACCOUNTS_PATH } from '@orbit/bank-accounts'

import * as SC from './styles'

export const columns = (onDelete: (item: any) => void): TableColumn<BankAccount>[] => [
  {
    title: 'Account Number',
    align: 'left',
    width: '250px',
    sortable: false,
    render: ({ accountNumber, id }) => (
      <Link to="/bank-accounts/$bankAccountId" params={{ bankAccountId: id.toString() }}>
        <TextMask isBankAccount text={accountNumber} iconSize={IconSize.XS} />
      </Link>
    )
  },
  {
    title: 'Licensed',
    align: 'center',
    sortable: false,
    width: '100px',
    render: ({ isLicensed }) => (
      <SC.Licensed>
        <CheckBox value={isLicensed} checkBoxLabel="" />
      </SC.Licensed>
    )
  },
  {
    title: 'Notes',
    key: 'notes',
    sortable: false,
    align: 'left'
  },
  {
    title: 'Actions',
    sortable: false,
    width: '100px',
    render: (item: any) => (
      <TableActions
        items={[
          {
            type: 'details',
            url: `${BANK_ACCOUNTS_PATH}/${item.id}`
          },
          {
            type: 'edit',
            url: `${BANK_ACCOUNTS_PATH}/${item.id}/edit?returnUrl=${window.location.pathname}`
          },
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
        dataQaAttribute={`Bank accounts-menu-dots-button-${item.id}`}
      />
    )
  }
]
